import { Box } from "@mui/material";
import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { OutlinedTextFieldWysiwygProps } from "./type";

import { DashboardSkeleton } from "@/dashboard-design-system/Skeleton";

const WysiwygLoadingPlaceholder = () => (
  <Box sx={{ width: "100%" }}>
    <DashboardSkeleton variant="rounded" height={310} width="100%" />
  </Box>
);

export const OutlinedTextFieldWysiwyg = dynamic(
  () =>
    import("./OutlinedTextFieldWysiwygSsr").then((mod) => {
      const Component = <T extends FieldValues>(props: OutlinedTextFieldWysiwygProps<T>) => {
        return <mod.OutlinedTextFieldWysiwygSsr {...props} />;
      };
      Component.displayName = "OutlinedTextFieldWysiwyg";
      return Component;
    }),
  { ssr: false, loading: WysiwygLoadingPlaceholder }
) as <T extends FieldValues>(props: OutlinedTextFieldWysiwygProps<T>) => React.ReactElement;
